var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.images),function(item){return _c('div',{key:item.id,class:'col-sm-' + _vm.size},[_c('img',{staticClass:"w-100",attrs:{"src":require('@/assets/' + _vm.path + item + ''),"alt":""}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }